import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "left-3ve9G",
  "use": "left-3ve9G-usage",
  "viewBox": "0 0 14 14",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 14 14\" id=\"left-3ve9G\"><path d=\"M0 7.021L7.049 14l1.628-1.639-4.173-4.202H14V5.841H4.504l4.173-4.202L7.049 0z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol